import logger from "@next/core-logger"
import {axiosInstance as axios} from "../../utils/axios"
import PrsApiConfig from "../../config/api/personalizationRetrievalService"
import {
    REALTIME_API_PATH,
    PERSONALISATION_ENDPOINT,
    PERSONALISATION_ANON_ENDPOINT,
    PERSONALISATION_ERROR_RESPONSE,
} from "../../config/constants"
import env from "../../config/env"
import {isAnonymous} from "../../utils/realTimePersonalisation"

export const getOrigin = (siteUrl: string) => {
    const urlObj = new URL(siteUrl)
    return urlObj.origin
}

export const getPrsMasId = async (
    rpId: string,
    realm: string,
    territory: string,
    language: string,
    siteUrl: string,
    firstName: string,
): Promise<string | undefined> => {
    try {
        const baseUrl = `${getOrigin(siteUrl)}${
            env.REACT_APP_SERVE_PATH_PREFIX ? `/${env.REACT_APP_SERVE_PATH_PREFIX}` : ""
        }${REALTIME_API_PATH}`

        const endpoint = isAnonymous(firstName) ? "/v1/masid-anon/" : "/v1/masid/"
        const getPrsDataApi = PrsApiConfig("getPrsData")
        const response = await axios({
            method: getPrsDataApi.method,
            url: `${baseUrl}/${realm}/${territory}/${language}${endpoint}${rpId}`,
        })
        if (!response.data.masid) return
        const masIdPrefix = "ID="
        return `${masIdPrefix}${response.data.masid}`
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        return undefined
    }
}

export const getPersonalisationData = async (
    rpId: string,
    realm: string,
    territory: string,
    language: string,
    siteUrl: string,
    isAnonymous: boolean,
    prsAPIVersion: string,
): Promise<JSON | string> => {
    try {
        const baseUrl = `${getOrigin(siteUrl)}${
            env.REACT_APP_SERVE_PATH_PREFIX ? `/${env.REACT_APP_SERVE_PATH_PREFIX}` : ""
        }${REALTIME_API_PATH}`

        const endpoint = `/${prsAPIVersion}/${isAnonymous ? PERSONALISATION_ANON_ENDPOINT : PERSONALISATION_ENDPOINT}`
        const getPrsDataApi = PrsApiConfig("getPrsData")

        const response = await axios({
            method: getPrsDataApi.method,
            url: `${baseUrl}/${realm}/${territory}/${language}${endpoint}${rpId}`,
        })

        // PERSONALISATION_ERROR_RESPONSE will be processed when the data is saved to session storage
        return response.status === 200 ? response.data : PERSONALISATION_ERROR_RESPONSE
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        return PERSONALISATION_ERROR_RESPONSE
    }
}
